import { Box, Button, CircularProgress } from "@material-ui/core";
import { MenuItem, Select, TextField, Typography } from "@mui/material";
import { Chat, Plus, Trash, User, X } from "phosphor-react";
import { useEffect, useState } from "react";
import { fget, fpost } from "../../../../API/callsAPI";
import inviteUserModalStyles from "./inviteUserModal.styles";
import MovieColabWarnings from "../../../Utilities/ErrorOrSuccessMessage/MovieColabWarnings";

const InviteUserModal = ({
  teamId,
  handleRefresh,
  inviteType,
  projectId,
  setSnackValue,
}) => {
  const classes = inviteUserModalStyles();
  const [isInviting, setIsInviting] = useState(false);
  // State to store all email-role pairs
  const [collaborators, setCollaborators] = useState([
    { email: "", role: "user" },
  ]);

  // Handle email input change
  const handleEmailChange = (index, value) => {
    const updated = [...collaborators];
    updated[index].email = value;
    setCollaborators(updated);
  };

  // Handle role select change
  const handleRoleChange = (index, value) => {
    const updated = [...collaborators];
    updated[index].role = value;
    setCollaborators(updated);
  };

  // Add new collaborator row
  const handleAddCollaborator = () => {
    // ensure last email is valid before adding a new row
    const lastEmail = collaborators[collaborators.length - 1]?.email || "";
    if (!/\S+@\S+\.\S+/.test(lastEmail)) return;
    setCollaborators((prev) => [...prev, { email: "", role: "user" }]);
  };

  // Optional: handle submit
  const handleSendInvites = async () => {
    console.log("Invites:", collaborators);
    try {
      setIsInviting(true);
      const inviteData = {
        url:
          inviteType === "team"
            ? `project-space/${teamId}/invite-user/`
            : `project/${projectId}/add_user/`,
        data: { users: collaborators },
      };
      await fpost(inviteData);

      setIsInviting(false);
      handleRefresh();
      setSnackValue({
        isOpen: true,
        message: `SuccessFully Invited`,
        isError: false,
      });
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
      setIsInviting(false);
    }
  };

  // compute disabled state for Add button
  const isAddDisabled = !/\S+@\S+\.\S+/.test(
    collaborators[collaborators.length - 1]?.email || "",
  );

  const [currentTierDetails, setCurrentTierDetails] = useState();
  useEffect(() => {
    const handleGetTierStatus = async () => {
      try {
        const res = await fget({
          url: `project-space/${teamId}/tier-status/`,
        });
        setCurrentTierDetails(res?.data);
      } catch (error) {
        console.log(error);
      }
    };
    if (teamId && inviteType === "team") {
      handleGetTierStatus();
    }
  }, [teamId]);

  return (
    <Box className={classes.inviteToProjectModalRoot}>
      <Box
        className={classes.flexCenter}
        style={{ justifyContent: "space-between", paddingBottom: "16px" }}
      >
        <Typography variant="h5" className={classes.title}>
          Invite To {inviteType === "team" ? "Team" : "Project"}
        </Typography>
        <Button onClick={handleRefresh}>
          <X size={22} />
        </Button>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {collaborators.map((collab, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginTop: index > 0 ? "10px" : 0,
            }}
          >
            <Box style={{ width: "100%" }} className={classes.cardContentDiv3}>
              <TextField
                value={collab.email}
                onChange={(e) => handleEmailChange(index, e.target.value)}
                className={classes.cardContentInput1}
                fullWidth
                placeholder="Enter email address"
              />
            </Box>

            <Select
              value={collab.role}
              onChange={(e) => handleRoleChange(index, e.target.value)}
              className={classes.selectRoleDropdown}
              MenuProps={{
                PaperProps: {
                  style: {
                    backgroundColor: "#252A38",
                    color: "#fff !important",
                    fontFamily: "Poppins !important",
                  },
                },
              }}
              labelId={`role-select-${index}`}
              id={`role-select-${index}`}
            >
              {/* <MenuItem value="admin" className={classes.singleRole}>
              <Shield size={20} />
              Admin
            </MenuItem> */}
              <MenuItem value="reviewer" className={classes.singleRole}>
                <Chat size={20} />
                Reviewer
              </MenuItem>
              <MenuItem value="user" className={classes.singleRole}>
                <User size={20} />
                User
              </MenuItem>
              <MenuItem value="freelancer" className={classes.singleRole}>
                <User size={20} />
                Freelancer
              </MenuItem>
            </Select>
            {index !== 0 ? (
              <Button
                onClick={() => {
                  // use functional update to avoid stale state and remove the clicked index
                  setCollaborators((prev) =>
                    prev.filter((_, i) => i !== index),
                  );
                }}
              >
                <Trash size={22} color="red" />
              </Button>
            ) : (
              ""
            )}
          </Box>
        ))}
      </Box>
      {Number(currentTierDetails?.total_users) >=
      Number(currentTierDetails?.tier_total_users) ? (
        <MovieColabWarnings
          warningText={`You've hit the user cap on your current plan. Upgrade your team plan to unlock more seats.`}
        />
      ) : (
        <Button
          startIcon={<Plus />}
          onClick={handleAddCollaborator}
          disabled={
            isAddDisabled ||
            Number(currentTierDetails?.total_users) >=
              Number(currentTierDetails?.tier_total_users)
          }
          style={{
            textTransform: "none",
            color: isAddDisabled ? "gray" : "white",
            marginTop: "10px",
            marginBottom: "16px",
          }}
        >
          Add another email ID
        </Button>
      )}

      <Box className={classes.footer}>
        <Button
          variant="contained"
          className={classes.button}
          onClick={handleSendInvites}
          disabled={
            isInviting ||
            Number(currentTierDetails?.total_users) >=
              Number(currentTierDetails?.tier_total_users)
          }
        >
          {isInviting ? <CircularProgress size={20} /> : " Send Invites"}
        </Button>
      </Box>
    </Box>
  );
};

export default InviteUserModal;
